export default "__VITE_ASSET__BksT$nkD__"